<template lang="pug">
.upload-contract-and-do(
  v-if="data != null"
  v-loading="loading"
)
  title-bar
    template(v-if="has_digital") {{ increment ? $t("增量Buying Brief") : $t('Buying Brief')  }}
    template(v-else) {{ increment ? $t('增量合同 & DO') : $t('合同 & DO') }}
  div(style="margin-left: 20px")
    el-row
      el-col(:span="4") {{ $t('Sub SOW') }}
      el-col(:span="10") {{ data.sub_final_scope_name  }}
    el-row
      el-col(:span="4") {{ $t('供应商') }}
      el-col(:span="10") {{ data.vendor_name_ch }}/{{ data.vendor_name }}
    category(:data="data.category_scope")
    template(v-if="has_digital")
      el-row
        el-col.required(:span="4") {{ increment ? $t('增量Buying Brief号') : $t('Buying Brief号') }}
        el-col(:span="20")
          el-input(
            v-if="!isView"
            v-model="buyingBriefNo"
            style="width: 180px"
          )
          span(
            v-else
          ) {{ buyingBriefNo }}
      el-row
        el-col.required(:span="4") {{ increment ? $t('增量Buying Brief附件') : $t('Buying Brief附件') }}
        el-col(:span="20")
          template(v-if="isView")
            uploaded-file-display(
              :fileName="buyingBrief.file_name"
              :downloadUrl="buyingBrief.file_download_path"
              :fileNameList="buyingBrief.file_name_list"
              width="85px"
            )
          template(v-else)
            div(style="display: flex")
              new-upload-file(
                axiosUrl="/management/subfinal/saveFile"
                :params="{campaign_id: campaignId,file_type:17}"
                @loadingChange="status => loading = status"
                @uploadSuccess="uploadBuyingBriefSuccess"
              )
              uploaded-file-display(
                style="margin-left: 10px"
                :fileName="buyingBrief.file_name"
                :downloadUrl="buyingBrief.file_download_path"
                :fileNameList="buyingBrief.file_name_list"
                width="85px"
              )
  title-bar(v-if="has_digital && category_count > 1") {{ increment ? $t('增量合同 & DO') : $t('合同 & DO') }}
  template(v-if="needUploadContractDO || (!has_digital)")
    div(
      v-if="isView"
      style="margin-left: 20px"
    )
      div(v-for="(item, index) in contract.filter(i => i.is_increment === this.increment)")
        contract-and-do-item(:item="item" :index="index")
    div(v-else style="margin-left: 20px")
      template(v-for="(item, index) in contract.filter(i => i.is_increment === this.increment)")
        el-row(v-if="index !== 0")
          el-col(:span="8" :offset="3")
            hr(style="border: 0.5px solid #ccc")
        el-row
          el-col.required(:span="4") {{ increment ? $t('增量DO号') : $t('DO号') }}
          el-col(:span="6")
            el-input(
              v-model="item.do_no"
              style="width: 180px"
            )
            el-button(
              v-if="index !== 0"
              icon="el-icon-delete"
              circle
              style="margin-left: 5px"
              @click="handleDeleteDO(index)"
            )
        el-row
          el-col.required(:span="4") {{ increment ? $t('增量合同号') : $t('合同号') }}
          el-col(:span="4")
            el-input(
              v-model="item.contract_no"
              style="width: 180px"
            )
        upload-file(
          axiosUrl="/management/subfinal/saveFile"
          :params="uploadParams"
          :text="increment ? $t('增量合同'): $t('合同')"
          @uploading="loading = true"
          @success="res => uploadSuccess(res, index)"
          :fileName="item.file_name"
          :downloadUrl="item.file_download_path"
          :canEdit="isView"
        )
      el-row
        el-col(:span="4" :offset="4")
          el-button(
            @click="addDo"
            type="text"
          ) +{{ $t('添加DO') }}
  div(style="margin-left: 20px")
    el-row(v-if="!isView")
      el-col(
        :span="20"
        :offset="4"
      )
        footer-button(
          @confirm="submit"
          @cancel="$router.push('/campaign/process')"
          :confirmButton="isView ? $t('保存') : $t('提交')"
        )
  SendEmailDialog(
    :email="email"
    :visible="visible"
    @cancel="visible = false"
    @confirm="handleSendEmail"
  )

</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import SubFinalScope from '@/components/SubFinalScope'
import { format4backend } from '@/umcc/util'
import SendEmailDialog from '@/components/SendEmailDialog'
import UploadFile from '@/components/UploadFile'
import Category from '@/components/Category'
import ContractAndDoItem from '@/components/ContractAndDoItem'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'

export default {
  props: {
    increment: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      data: null,
      contract: [
        {
          do_no: '',
          contract_no: '',
          contract_path: '',
          contract_download_path: '',
          contract_name: '',
          is_increment: this.increment
        }
      ],
      visible: false,
      email: '',
      cc: '',
      signature_completed: false,
      has_digital: true,
      needUploadContractDO: true,
      category_count: 1,
      buyingBrief: {
        file_name: null,
        file_path: null,
        file_download_path: null
      },
      buyingBriefNo: '',
      loading: false
    }
  },
  computed: {
    campaign () {
      return this.$store.state.campaign
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 4
      }
    },
    taskName () {
      return this.$store.state.campaign.taskName
    }
  },
  mounted () {
    if (this.isView) {
      this.getSubFinalScopeList()
    }
    this.fetchContract()
    this.fetchEmail()
    this.checkSubFinalScopeCategory()
  },
  methods: {
    fetchEmail () {
      axios.get('/management/subfinal/getVendorUser', {
        params: { sub_final_scope_id: this.subFinalScopeId }
      })
        .then(res => {
          this.email = res.mail
        })
    },
    fetchContract () {
      this.loading = true
      axios.get('/management/subfinal/getContractInfo', {
        params: { sub_final_scope_id: this.subFinalScopeId }
      })
        .then(res => {
          this.data = res
          this.contract = res.contracts
          if (this.contract.filter(i => i.is_increment === this.increment).length === 0) this.addDo()
          if (this.increment) {
            this.buyingBrief = {
              file_download_path: res.buying_brief_increment_download_url,
              file_name: res.buying_brief_increment_file_name,
              file_path: res.buying_brief_increment_path
            }
            this.buyingBriefNo = res.buying_brief_increment_no
          } else {
            this.buyingBrief = {
              file_download_path: res.buying_brief_download_url,
              file_name: res.buying_brief_file_name,
              file_path: res.buying_brief_path
            }
            this.buyingBriefNo = res.buying_brief_no
          }
          this.loading = false
        })
    },
    addDo () {
      const CONTRACT = {
        do_no: null, // do 号
        contract_no: null, // 合同号
        contract_path: null, // 合同路径
        contract_download_path: null, // 合同下载路径
        contract_name: null, // 合同名
        is_increment: this.increment
      }
      this.contract.push(CONTRACT)
    },
    handleDeleteDO (index) {
      let result = this.contract.filter(i => i.is_increment === this.increment)
      result.splice(index, 1)
      let filterResult = this.contract.filter(i => i.is_increment !== this.increment)
      this.contract = result.concat(filterResult)
    },
    async submit () {
      if (!this.validateInfo()) return
      try {
        this.loading = true
        const res = await axios.get('/common/canEditCampaign', {
          params: {
            campaign_id: this.campaignId,
            task_name: this.taskName
          }
        })
        this.loading = false
        if (!res.can_edit) {
          this.$message.error(this.$t('您无权限编辑当前页面'))
        } else {
          this.saveContract()
        }
      } catch (err) {
        throw new Error(err)
      }
    },
    onConfirm () {
      this.visible = true
    },
    handleSendEmail (email, cc) {
      this.email = email
      this.cc = cc
      this.visible = false
      this.submit()
    },
    uploadSuccess (res, index) {
      const currentContract = this.contract.filter(i => i.is_increment === this.increment)
      currentContract[index].contract_path = res.file_path
      currentContract[index].contract_name = res.file_name
      currentContract[index].contract_download_path = res.file_download_path
      this.loading = false
    },
    validateInfo () {
      const hasEmptyResult = Boolean(this.contract
        .filter(i => i.is_increment === this.increment)
        .find(i => !i.do_no || !i.contract_no || !i.contract_path))

      const contractNOPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[0-9a-zA-Z]{14}$/
      const invalidNOPattern = Boolean(this.contract
        .filter(i => i.is_increment === this.increment)
        .some(i => !contractNOPattern.test(i.contract_no)))

      const DOPattern = /(^DO)[0-9]{8}$/
      const invalidDOPattern = Boolean(this.contract
        .filter(i => i.is_increment === this.increment)
        .some(i => !DOPattern.test(i.do_no)))

      if (this.needUploadContractDO && hasEmptyResult) {
        this.$message.error(this.$t('请填写必填项'))
        return false
      }

      if (this.has_digital && !this.buyingBriefNo) {
        this.$message.error(this.$t('请填写Buying Brief号'))
        return false
      }

      if (this.has_digital && !this.buyingBrief.file_path) {
        this.$message.error(this.$t('请上传Buying Brief'))
        return false
      }

      if (this.needUploadContractDO && invalidDOPattern) {
        this.$message.error(this.$t('请输入正确的DO号'))
        return false
      }
      if (this.needUploadContractDO && invalidNOPattern) {
        this.$message.error(this.$t('请输入正确的合同号'))
        return false
      }
      return true
    },
    getSubFinalScopeList () {
      axios.get('/management/subfinal/getSubFinalScopeList', {
        params: {
          campaign_id: this.campaignId
        }
      })
        .then(res => {
          res.forEach(item => {
            if (item.sub_final_scope_id === this.subFinalScopeId) {
              this.signature_completed = item.signature_completed
            }
          })
        })
    },
    async checkSubFinalScopeCategory () {
      try {
        const res = await axios.get('/management/subfinal/checkSubFinalScopeCategory', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        this.has_digital = res.has_digital
        this.category_count = res.category_count
        this.needUploadContractDO = (res.has_digital && res.category_count > 1) || !res.has_digital
      } catch (err) {
        throw new Error(err)
      }
    },
    uploadBuyingBriefSuccess (res) {
      this.buyingBrief = res
    },
    saveContract () {
      this.loading = true
      const params = {
        campaign_id: this.$store.state.campaign.id,
        servlet_path: this.$route.path,
        task_name: this.campaign.taskName,
        task_id: this.campaign.taskId,
        business_type: this.$store.state.campaign.businessType,
        sub_final_scope_id: this.subFinalScopeId
      }

      if (this.has_digital) {
        if (this.increment) {
          params.buying_brief_increment_path = this.buyingBrief.file_path
          params.buying_brief_increment_no = this.buyingBriefNo
        } else {
          params.buying_brief_path = this.buyingBrief.file_path
          params.buying_brief_no = this.buyingBriefNo
        }
      }

      if (this.needUploadContractDO) {
        params.sub_final_scope_contract = this.contract.filter(i => i.is_increment === this.increment).map(item => ({
          sub_final_scope_id: this.subFinalScopeId,
          do_no: item.do_no,
          contract_no: item.contract_no,
          contract_path: item.contract_path,
          is_increment: item.is_increment
        }))
      }

      let apiPath
      if (this.isView) {
        apiPath = this.increment ? '/management/subfinal/updateIncrementContract' : '/management/subfinal/updateContract'
      } else {
        apiPath = this.increment ? '/management/subfinal/saveIncrementContract' : '/management/subfinal/saveContract'
      }
      axios.post(apiPath, format4backend(params))
        .then(res => {
          if (this.increment) {
            this.$store.commit('campaign/setPhaseType', 4)
          }
          this.$message.success(this.$t('提交成功'))
          this.loading = false
          this.$router.push('/campaign/process')
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  },
  components: {
    ContractAndDoItem,
    TitleBar,
    FooterButton,
    SubFinalScope,
    SendEmailDialog,
    UploadFile,
    Category,
    NewUploadFile,
    UploadedFileDisplay
  }
}
</script>

<style lang="stylus">
.upload-contract-and-do
  .footer-button
    padding-left 0px
</style>
